import {Request} from "../core/request"
import {AuthHeader} from "../core/token";


export type TeacherCode = {
    code: string,
    count: number,
    disable: boolean,
    expTime: string,
    createdAt: string,
    updatedAt: string,
    deletedAt: string,
}

export async function getRegisterCode():Promise<TeacherCode[]> {
    const resp = await Request.get<TeacherCode[]>(`/super_admin/users/register_code`,  {headers: AuthHeader()})
    return resp.data
}


export async function createRegisterCode() {
    return await Request.post(`/super_admin/users/register_code`, {}, {headers: AuthHeader()});
}


export async function updateRegisterCode(code: string, reset_count: number = 15, disable: boolean = false, enable: boolean = true) {
    return await Request.put(`/super_admin/users/register_code/${code}`, {
        enable: enable,
        disable: disable,
        set_count: reset_count,
    }, {headers: AuthHeader()});
}


export async function deleteRegisterCode(code: string) {
    return await Request.delete(`/super_admin/users/register_code/${code}`,  {headers: AuthHeader()});
}
